<template>
  <div class="bidDetail">
    <!-- 顶部导航 -->
    <div class="nav">
      <van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
      <span>{{ this.$route.query.title }}-{{ title.title }}</span>
      <span></span>
    </div>
    <div class="main" v-if="isLoding">
      <Loding></Loding>
    </div>
    <div class="main" v-else-if="isNone">
      <div class="none">暂无数据~</div>
    </div>
    <div class="main" v-else>
      <div class="list" v-for="item in serList" @click="goChain(item.id)">
        <van-card>
          <div slot="thumb" class="list_thumb">
            <img :src="item.slider_image[0] | handleUrl | ''" alt="" />
          </div>
          <div slot="title" class="list_title">
            {{ item.title }}
          </div>
          <div slot="desc" class="list_desc">
            {{ item.business }}
          </div>
          <div slot="price-top" class="list_priceTop">
            <div>评分</div>
            <div class="star">{{ item.fraction }}</div>
            <van-rate
              v-model="item.fraction / 2"
              :allow-half="true"
              color="#F1452F"
              size="0.8rem"
              readonly
            />
          </div>
          <div slot="price" class="list_price">
            <div>
              <van-icon name="location-o" />
              <div
                style="overflow-x:hidden;white-space:nowrap;text-overflow:ellipsis"
              >
                {{ item.city }}{{ item.area }}{{ item.address }}
              </div>
            </div>
            <div>{{ item.km }}km</div>
          </div>
        </van-card>
      </div>
    </div>
    <!--底部导航栏 -->
    <van-goods-action>
      <van-goods-action-icon icon="wap-home-o" text="首页" to="/Home" />
      <van-goods-action-icon icon="service-o" text="客服" @click="open53" />
      <!-- <van-goods-action-icon icon="location-o" text="附近" /> -->
      <van-goods-action-button
        type="danger"
        text="店铺入驻"
        @click="toPath('/idleNone')"
      />
    </van-goods-action>
    <!--登录 -->
    <van-popup
      v-model="loginPopupShow"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <div class="close-icon" @click="loginPopupShow = false">关闭</div>
      <Login :url="url"></Login>
    </van-popup>
  </div>
</template>

<script>
import Loding from "@/components/loding";
import Login from "@/components/login/login";

export default {
  data() {
    return {
      isNone: false,
      isLoding: true,
      serList: "",
      title: "",
      activeA: 0,
      activeB: 0,
      loginPopupShow: false,
      url: ""
    };
  },
  components: {
    Loding,
    Login
  },
  created() {
    //一级分类信息
    this.$axios
      .post(baseUrl + "/mobile/Category/thirdpartyTitle", {
        id: this.$route.query.id
      })
      .then(res => {
        if (res.data.code === 2) {
          this.title = res.data.data;
        }
      })
      .catch(err => {});
    //分类列表
    this.$axios
      .post(baseUrl + "/mobile/Category/thirdpartyList", {
        id: this.$route.query.id,
        lng: this.$store.state.location[0],
        lat: this.$store.state.location[1]
      })
      .then(res => {
        if (res.data.code === 2) {
          this.serList = res.data.data;
          this.isLoding = false;
        } else {
          this.isLoding = false;
          this.isNone = true;
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    goChain(id) {
      this.$router.push({
        path: "/chain",
        query: {
          id: id
        }
      });
    },
    //条件筛选栏
    clicks(name) {
      // if (name === 3) {
      //   this.toPath('/Min')
      // }
    },
    //验证登录
    toPath(path) {
      this.whatLogin(bool => {
        if (bool) {
          this.$router.push({
            path: path
          });
        } else {
          this.loginPopupShow = true;
          this.url = path;
        }
      });
    }
  }
};
</script>

<style scoped>
.bidDetail {
  padding: 0 0 3rem 0;
}

.close-icon {
  color: #fff;
  position: absolute;
  z-index: 4000;
  font-size: 0.8rem;
  top: 3.5rem;
  left: 1rem;
}

.van-card {
  background: #fff;
}

.van-card__header {
  align-items: center;
}

.bidDetail .tabs_title {
  display: flex;
  align-items: center;
  justify-content: center;
}

.bidDetail .navBar {
  position: fixed;
  width: 100%;
  z-index: 2000;
}

.bidDetail .main {
  padding: 0 0.7rem;
  box-sizing: border-box;
  margin-top: 2.5rem;
}

.bidDetail .main .none {
  color: #969799;
  font-size: 0.8rem;
  margin-top: 3rem;
}

.bidDetail .main .list {
  border-radius: 0.5rem;
  overflow: hidden;
  margin: 0.7rem 0;
}

.bidDetail .main .list .van-card__content {
  text-align: left;
  padding-left: 0.5rem;
  box-sizing: border-box;
  color: #2f2f2f;
}

.bidDetail .list .list_thumb {
  width: 100%;
  height: 100%;
}

.bidDetail .list .list_thumb img {
  width: 100%;
  height: 100%;
  border-radius: 0.3rem;
  object-fit: cover;
}

.bidDetail .list .list_title {
  font-size: 1rem;
  color: #000;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bidDetail .list .list_desc {
  margin-top: 0.3rem;
  font-size: 0.8rem;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.bidDetail .list .list_priceTop {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
}

.bidDetail .list .list_priceTop .star {
  color: #f1452f;
  font-size: 1rem;
  margin: 0 0.5rem;
}

.bidDetail .list .list_price {
  margin-top: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.van-card__price {
  display: block;
}

.bidDetail .list .list_price > div:nth-child(1) {
  width: 60%;
  display: flex;
  align-items: center;
}

.bidDetail .list .list_price > div:nth-child(2) {
  width: 5.1rem;
  margin-left: 1.2rem;
  color: #f1452f;
}
</style>



// WEBPACK FOOTER //
// src/components/class/ser_detail.vue